<template>
	<div class="nk-app-root">
		<!-- main @s -->
		<div class="nk-main">
			<!-- wrap @s -->
			<div class="nk-wrap">
				<Header />
				<!-- content @s -->
				<div class="nk-content">
					<div class="container wide-large">
						<div class="nk-content-inner">
							<div class="nk-content-body">
								<div v-if="!loading && inspection_count == 0">
									<h3>This project has no content yet.</h3>
								</div>
								<div class="card card-preview" style="margin-bottom: 20px"
									v-if="!loading && inspection_count > 0">
									<!-- Breadcrumb Navigation -->
									<div class="breadcrumb-container" v-if="breadcrumbs.length > 0">
										<div class="breadcrumb-left">
											<button class="btn btn-sm btn-icon sidebar-toggle-btn"
												@click="sidebarCollapsed = !sidebarCollapsed"
												:title="sidebarCollapsed ? 'Sidebar einblenden ([)' : 'Sidebar ausblenden (])'">
												<span class="material-icons">
													{{ sidebarCollapsed ? 'menu' : 'menu_open' }}
												</span>
												<span class="sidebar-count" v-if="!sidebarCollapsed">{{
													inspections.length }}</span>
											</button>
											<nav aria-label="breadcrumb">
												<ol class="breadcrumb mb-0">
													<li v-for="(crumb, index) in breadcrumbs" :key="index"
														class="breadcrumb-item"
														:class="{ active: index === breadcrumbs.length - 1 }">
														<router-link
															v-if="crumb.route && index < breadcrumbs.length - 1"
															:to="crumb.route">
															{{ crumb.label }}
														</router-link>
														<span v-else>{{ crumb.label }}</span>
													</li>
												</ol>
											</nav>
										</div>
										<div class="breadcrumb-right-actions">
											<button class="btn btn-sm lang-toggle" @click="switchLanguage"
												:title="lang === 'de' ? 'Switch to English' : 'Zu Deutsch wechseln'">
												{{ lang === 'de' ? 'EN' : 'DE' }}
											</button>
											<button class="btn btn-sm btn-icon shortcut-hint"
												@click="showShortcutOverlay = true" title="Keyboard Shortcuts (?)">
												<span class="material-icons">keyboard</span>
											</button>
										</div>
									</div>

									<div>
										<div class="preview-block">
											<div class="row" style="margin: 0">
												<div :class="sidebarCollapsed ? 'sidebar-hidden' : 'col-sm-2'"
													style="padding: 0px;" v-show="!sidebarCollapsed">
													<div class="container-col1">
														<div class="content-col1">
															<table class="table">
																<tbody>
																	<tr v-for="item in inspections" :key="item.uid"
																		:class="{
																			insection_selected:
																				item.uid === inspect_id,
																		}" class="inspection-row" @click="selectInspectionRow(item)">
																		<td
																			:style="'border-left: 8px solid ' + item.color + ' !important'">
																			<div class="custom-checkbox custom-control custom-control-sm"
																				style="padding-top:4px;" @click.stop>
																				<input type="checkbox"
																					class="custom-control-input"
																					:id="'customCheck-' + item.uid"
																					v-model="selectedInspections"
																					:value="item.uid" />
																				<label class="custom-control-label"
																					:for="'customCheck-' + item.uid"></label>
																			</div>
																			<span>
																				<b>{{ item.machineName }}</b>
																				<div>{{ item.project_cat }}</div>
																			</span>
																		</td>
																	</tr>
																</tbody>
															</table>
														</div>
														<div class="selection-controls mb-2 mt-2 ml-2"
															v-if="inspections && inspections.length > 0">
															<button class="btn btn-sm btn-outline-primary mr-1"
																@click="selectAll">
																Select All
															</button>
															<button class="btn btn-sm btn-outline-secondary mr-1"
																@click="deselectAll">
																Deselect All
															</button>
														</div>
													</div>
												</div>
												<div :class="middleColumnClass" class="chapter-column">
													<div v-if="inspection_loading">
														Loading inspection...
													</div>
													<div class="btn-list">
														<a href="#" @click="reportSettings(inspectionEntry)"
															class="btn btn-dim btn-outline-dark mr-1">Settings</a>
														<div class="dropdown">
															<a href="#" class="
                                          btn btn-primary
                                          dropdown-toggle
                                        " data-toggle="dropdown">
																Export Report
															</a>
															<div class="dropdown-menu dropdown-menu-right">
																<ul class="link-check">
																	<!-- Your existing options -->
																	<li>
																		<span v-if="lang == 'en'"
																			style="cursor: pointer"
																			@click="generatePdfReport(true)">Inspection
																			Report</span>
																		<span v-if="lang == 'de'"
																			style="cursor: pointer"
																			@click="generatePdfReport(true)">Prüfbericht</span>
																	</li>
																	<li>
																		<span v-if="lang == 'en'"
																			style="cursor: pointer"
																			@click="generatePdfReport(false)">Preview</span>
																		<span v-if="lang == 'de'"
																			style="cursor: pointer"
																			@click="generatePdfReport(false)">Vorschau</span>
																	</li>

																	<!-- Add new options for selected items -->
																	<li v-if="selectedInspections.length > 0">
																		<span v-if="lang == 'en'"
																			style="cursor: pointer"
																			@click="exportSelectedReports()">{{
																				selectedInspections.length
																			}}
																			Inspection Report(s)</span>
																		<span v-if="lang == 'de'"
																			style="cursor: pointer"
																			@click="exportSelectedReports()">{{
																				selectedInspections.length
																			}}
																			Prüfbericht(e)</span>
																	</li>
																</ul>
															</div>
														</div>
													</div>

													<div v-if="!inspection_loading">
														<h4 v-if="inspectionEntry">
															{{ inspectionEntry.machine.name }}

															<span v-if="inspectionEntry.machine.siteNumber">({{
																inspectionEntry.machine.siteNumber
															}})</span>
														</h4>

														<div v-if="versionList && versionList.length > 1"
															style="margin-top: 10px">
															<select class="form-control" v-model="lastVersion"
																@change="changeVersion()">
																<option v-for="(item, index) in versionList"
																	:key="index" :value="item">
																	{{ item.type }}{{ item.revision }}
																</option>
															</select>
														</div>

														<div v-if="inspectionEntry" style="
                                font-size: 12px;
                                padding-top: 12px;
                                margin-top: 10px;
                                border-top: 1px solid #cccccc;
                              ">
															<span> {{ reportName }}</span>
															<div v-if="inspection_base">
																{{ inspection_base.project_cat }}
																({{ lastVersion.type
																}}{{ lastVersion.revision }})
															</div>
														</div>

														<div v-if="inspectionEntry"
															style="font-size: 12px; margin-top: 10px">
															<span v-if="
																inspectionContent &&
																inspectionContent.title &&
																inspectionContent.machineManufacturer
															" class="badge badge-outline-info">{{
																	inspectionContent.title.machineManufacturer
																		.text
																}}</span>

															<div class="chapterTable">
																<div class="chapter-headline"
																	@click="selectChapter('general')" v-if="
																		inspectionContent &&
																		inspectionContent.general &&
																		inspectionContent.general.title
																	">
																	<h6>
																		{{ inspectionContent.general.title.text }}
																	</h6>
																</div>

																<div class="chapter-headline"
																	@click="selectChapter('machinedata')" v-if="
																		inspectionContent &&
																		inspectionContent.machinedata &&
																		inspectionContent.machinedata.title
																	">
																	<h6>
																		{{
																			inspectionContent.machinedata.title.text
																		}}
																	</h6>
																</div>
																<div v-if="
																		inspectionContent &&
																		inspectionContent.components &&
																		inspectionContent.components.title &&
																		inspectionContent.components.list.length > 0
																	">
																	<div class="chapterRow">
																		<div class="chapterRow-col2"
																			@click="selectChapter('components')">
																			<strong>{{ inspectionContent.components.title.text }}</strong>
																		</div>
																		<div class="chapterRow-col1"></div>
																		<div class="chapterRow-col3">
																			<div class="chaper-icon"
																				@click="componentSettings()">
																				<span class="material-icons">settings</span>
																			</div>
																		</div>
																	</div>
																</div>

																<div class="chapter-headline">
																	<h6>
																		{{
																			inspectionContent &&
																			inspectionContent.findings &&
																			inspectionContent.findings.title &&
																			inspectionContent.findings.title.text
																		}}
																	</h6>
																</div>

																<div v-for="item in findingsChapters" :key="item.uid">
																	<div class="chapterRow">
																		<div class="chapterRow-col2"
																			@click="selectFindingsChapter(item)">
																			<span
																				v-if="item.level == 3">&nbsp;&nbsp;</span>
																			<span
																				v-if="item.level == 4">&nbsp;&nbsp;&nbsp;&nbsp;</span>
																			<span
																				v-if="item.level == 5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
																			{{ item.title.chapter }}
																			{{ item.title.text }} ({{ item.count }})
																		</div>
																		<div class="chapterRow-col1">
																			<div class="chaper-icon"
																				@click="chapterImage(item)"
																				v-if="item.chapterimage">
																				<span
																					class="material-icons">image</span>
																			</div>
																		</div>
																		<div class="chapterRow-col3">
																			<div class="chaper-icon"
																				@click="chapterSettings(item)">
																				<span
																					class="material-icons">settings</span>
																			</div>
																		</div>
																	</div>
																</div>
																<div class="chapter-headline"
																	@click="selectChapter('conclusion')" v-if="
																		inspectionContent &&
																		inspectionContent.conclusion &&
																		inspectionContent.conclusion.title
																	">
																	<h6>
																		{{
																			inspectionContent.conclusion.title.text
																		}}
																	</h6>
																</div>
															</div>
															<div>
																<div class="btn-group" aria-label="Basic example" v-if="
																	!pdfLoading &&
																	findingsChapters &&
																	findingsChapters.length > 0
																">
																	<button type="button"
																		@click="generatePdfReport(true)"
																		class="btn btn-primary">
																		<span v-if="lang == 'en'">Inspection
																			Report</span>
																		<span v-if="lang == 'de'">Prüfbericht</span>
																	</button>
																	<button type="button"
																		@click="generatePdfReport(false)"
																		class="btn btn-dim btn-outline-dark">
																		<span v-if="lang == 'en'">Preview</span>
																		<span v-if="lang == 'de'">Vorschau</span>
																	</button>
																</div>

																<div v-if="pdfLoading"
																	class="spinner-border spinner-grow-sm"
																	role="status">
																	<span class="sr-only">Loading...</span>
																</div>

																<div class="mt-5">(v1.1.7)</div>
															</div>
														</div>
													</div>
												</div>
												<div :class="contentColumnClass" class="content-column">
													<div v-if="!inspection_loading">
														<div v-if="contentCategory == 'conclusion'">
															<h4 style="padding-bottom: 20px">
																{{ inspectionContent.conclusion.title.text }}
															</h4>
															<div>
																<table class="table table-sm">
																	<tbody>
																		<tr v-for="item in inspectionContent
																			.conclusion.list" :key="item.id">
																			<td>
																				<span class="badge badge-primary"
																					v-bind:style="stateColorStyle(item.state)
																						">{{ renameState(item.state) }}</span>
																			</td>
																			<td>
																				<div v-if="
																					item.reportText &&
																					item.reportText.length > 1
																				">
																					<b>{{ item.reportText }}</b><br />
																				</div>
																				{{ item.text }}
																			</td>
																		</tr>
																	</tbody>
																</table>
															</div>

															<div v-for="item in inspectionContent.conclusion
																.chapters" :key="item.id">
																<h6 style="padding-top: 20px">
																	{{ item.title.chapter }}
																	{{ item.title.text }}
																</h6>
																<p>{{ item.text }}</p>
															</div>
														</div>

														<div v-if="contentCategory == 'general'">
															<h4 style="padding-bottom: 20px">
																{{ inspectionContent.general.title.text }}
															</h4>
															<div v-for="item in inspectionContent.general.list"
																:key="item.id">
																<div v-if="item.type == 'list'"
																	style="padding-bottom: 20px">
																	<h6>
																		{{ item.title.chapter }}
																		{{ item.title.text }}
																	</h6>
																	<ol style="
                                      list-style-type: square;
                                      padding-left: 20px;
                                    ">
																		<li v-for="item2 in item.list" :key="item2.id">
																			{{ item2 }}
																		</li>
																	</ol>
																</div>
																<div v-if="item.type == 'table'"
																	style="padding-bottom: 20px">
																	<h6>
																		{{ item.title.chapter }}
																		{{ item.title.text }}
																	</h6>
																	<table class="table table-sm">
																		<tbody>
																			<tr v-for="item2 in item.list"
																				:key="item2.id">
																				<td>
																					<p>
																						{{ item2.split('=')[0] }}
																					</p>
																				</td>
																				<td>
																					{{ item2.split('=')[1] }}
																				</td>
																			</tr>
																		</tbody>
																	</table>
																</div>
															</div>
														</div>

														<h4 v-if="contentCategory == 'components'"
															style="padding-bottom: 20px">
															{{ inspectionContent.components.title.text }}
														</h4>
														<div v-if="!isPVOrBat">
															<table class="table table-sm"
																v-if="contentCategory == 'components'">
																<thead>
																	<tr>
																		<th>Komponenten</th>
																		<th>Hersteller</th>
																		<th>Typ</th>
																		<th>Seriennummer</th>
																	</tr>
																</thead>
																<tbody>
																	<tr v-for="item in inspectionContent.components
																		.list" :key="item.id">
																		<td>{{ item.component }}</td>
																		<td>{{ item.manufacturer }}</td>
																		<td>{{ item.type }}</td>
																		<td>{{ item.serialNumber }}</td>
																	</tr>
																</tbody>
															</table>
														</div>

														<h4 v-if="contentCategory == 'machinedata'"
															style="padding-bottom: 20px">
															{{ inspectionContent.machinedata.title.text }}
														</h4>
														<div v-if="!isPVOrBat">
															<table class="table table-sm"
																v-if="contentCategory == 'machinedata'">
																<thead>
																	<tr>
																		<th>Title</th>
																		<th>Text</th>
																	</tr>
																</thead>
																<tbody>
																	<tr v-for="item in inspectionContent.machinedata
																		.list" :key="item.id">
																		<td>{{ item.title }}</td>
																		<td>{{ item.text }}</td>
																	</tr>
																</tbody>
															</table>
														</div>
														<div v-if="
															isPVOrBat && contentCategory == 'machinedata'
														">
															<div v-if="
																inspectionContent.machinedata_pv.data
																	.identification
															">
																<div style="margin-bottom: 30px">
																	{{
																		inspectionContent.machinedata_pv.data
																			.identification_machine
																	}}
																</div>

																<div style="margin-bottom: 30px">
																	<h6>{{ $t('PV_IDENTIFICATION') }}</h6>
																	<table class="table table-sm">
																		<tbody>
																			<tr>
																				<td>{{ $t('PV_SOLAR_PARK') }}</td>
																				<td>
																					{{
																						inspectionContent.machinedata_pv
																							.data.identification.park
																					}}
																				</td>
																			</tr>
																			<tr>
																				<td>{{ $t('LOCATION') }}</td>
																				<td>
																					{{
																						inspectionContent.machinedata_pv
																							.data.identification.lat
																					}}
																					N;
																					{{
																						inspectionContent.machinedata_pv
																							.data.identification.lng
																					}}
																					E
																				</td>
																			</tr>
																			<tr>
																				<td>{{ $t('PV_CITY') }}</td>
																				<td>
																					{{
																						inspectionContent.machinedata_pv
																							.data.identification.city
																					}}
																				</td>
																			</tr>
																			<tr>
																				<td>{{ $t('PV_COUNTRY') }}</td>
																				<td>
																					{{
																						inspectionContent.machinedata_pv
																							.data.identification.country
																					}}
																				</td>
																			</tr>
																			<tr>
																				<td>{{ $t('PV_MACHINE_TYPE') }}</td>
																				<td>
																					{{
																						$t(
																							inspectionContent.machinedata_pv
																								.data.identification.type
																						)
																					}}
																				</td>
																			</tr>
																		</tbody>
																	</table>
																</div>
																<h6>{{ $t('PV_MODULE') }}</h6>
																<table style="margin-bottom: 10px"
																	class="table table-sm" v-for="(item, index) in inspectionContent
																		.machinedata_pv.data.pv_module_details" :key="index">
																	<tbody>
																		<tr>
																			<td>
																				{{ $t('MANUFACTURER') }} ({{
																					index + 1
																				}})
																			</td>
																			<td>
																				{{ item.manufacturer }}
																			</td>
																		</tr>
																		<tr>
																			<td>
																				{{ $t('TYPE') }} ({{ index + 1 }})
																			</td>
																			<td>
																				{{ item.type }}; {{ item.number }} St.
																			</td>
																		</tr>
																		<tr>
																			<td>
																				{{ $t('NOMINAL_POWER') }} ({{
																					index + 1
																				}})
																			</td>
																			<td>{{ item.power }} Wp</td>
																		</tr>
																	</tbody>
																</table>

																<table style="margin-bottom: 20px"
																	class="table table-sm">
																	<tbody>
																		<tr>
																			<td>{{ $t('PV_NUMBER_TOTAL') }}</td>
																			<td>
																				{{
																					inspectionContent.machinedata_pv.data
																						.pv_module_total
																				}}
																				St.
																			</td>
																		</tr>
																	</tbody>
																</table>

																<h6>{{ $t('FURTHER_DETAILS') }}</h6>
																<table style="margin-bottom: 10px"
																	class="table table-sm">
																	<tbody>
																		<tr>
																			<td>{{ $t('PV_GRID_CONNECTION') }}</td>
																			<td>
																				{{
																					inspectionContent.machinedata_pv.data
																						.pv_grid_connection
																				}}
																			</td>
																		</tr>
																		<tr>
																			<td>{{ $t('PV_GRID_OPERATOR') }}</td>
																			<td>
																				{{
																					inspectionContent.machinedata_pv.data
																						.pv_grid_operator
																				}}
																			</td>
																		</tr>
																		<tr>
																			<td>{{ $t('PV_INSTALLER') }}</td>
																			<td>
																				{{
																					inspectionContent.machinedata_pv.data
																						.pv_installer
																				}}
																			</td>
																		</tr>
																		<tr>
																			<td>{{ $t('PV_OWNER') }}</td>
																			<td>
																				{{
																					inspectionContent.machinedata_pv.data
																						.pv_owner
																				}}
																			</td>
																		</tr>
																		<tr>
																			<td>{{ $t('PV_COMMISSIONING_EEB') }}</td>
																			<td>
																				{{
																					inspectionContent.machinedata_pv.data
																						.pv_comission_eeb
																				}}
																			</td>
																		</tr>
																		<tr>
																			<td>{{ $t('PV_COMMISSIONING') }}</td>
																			<td>
																				{{
																					inspectionContent.machinedata_pv.data
																						.pv_comission
																				}}
																			</td>
																		</tr>
																	</tbody>
																</table>
															</div>
														</div>
														<h4 v-if="
															selected_item && contentCategory == 'findings'
														">
															{{ selected_item.title.text }}

															<span v-if="
																inspectionContent.processingState.map[
																selected_item.uid
																]
															">({{
																	inspectionContent.processingState.map[
																		selected_item.uid
																	].istzustand
																}}%)</span>
														</h4>

														<!-- Status Filter -->
														<div class="status-filter-bar"
															v-if="contentCategory == 'findings' && findingsForChapter.length > 0">
															<span class="filter-label">Filter:</span>
															<button v-for="state in availableStates" :key="state"
																class="btn btn-sm status-filter-btn" :class="{
																	active: statusFilter.includes(state),
																	'btn-outline-secondary': !statusFilter.includes(state)
																}" :style="statusFilter.includes(state) ? stateColorStyle(state) : {}"
																@click="toggleStatusFilter(state)"
																:disabled="statusCounts[state] === 0">
																{{ renameState(state) }}
																<span class="badge badge-light ml-1">{{
																	statusCounts[state] }}</span>
															</button>
															<button v-if="statusFilter.length > 0"
																class="btn btn-sm btn-link" @click="statusFilter = []">
																Alle zeigen
															</button>
															<!-- Suchfeld für Findings -->
															<div class="findings-search">
																<input type="text" class="form-control form-control-sm"
																	v-model="findingsSearch" placeholder="Suchen..." />
																<span v-if="findingsSearch" class="search-clear"
																	@click="findingsSearch = ''">×</span>
															</div>
															<span class="filter-result-count">
																{{ filteredFindings.length }} / {{
																	findingsForChapter.filter(i => !i.invisible).length }}
															</span>
														</div>

														<div class="findings-table-container"
															v-if="contentCategory == 'findings'">
															<table class="table table-sm findings-table">
																<thead class="sticky-header">
																	<tr>
																		<th style="width: 80px">Nr</th>
																		<th style="width: 50px"></th>
																		<th>Result</th>
																	</tr>
																</thead>
																<tbody>
																	<tr v-for="(item, index) in filteredFindings"
																		:key="index">
																		<td>
																			<span v-if="
																				!isProcessingControl && !item.hideRating
																			">{{ getFullFindingNumber(item.pos) }}
																			</span>
																			<span v-if="
																				isProcessingControl && !item.hideRating
																			">{{ getFullFindingNumber(item.pos_local) }}
																			</span>
																		</td>
																		<td>
																			<div class="status-cell">
																				<span v-if="!item.hideRating"
																					class="badge badge-primary"
																					v-bind:style="stateColorStyle(
																						item.last_state
																							? item.last_state
																							: item.state
																					)
																						">{{
																					renameState(
																						item.last_state
																							? item.last_state
																							: item.state
																					)
																				}}</span>
																				<button
																					class="btn btn-sm btn-icon comment-btn"
																					@click.stop="openFindingComments(item)"
																					:title="getCommentButtonTitle(item)">
																					<span
																						class="material-icons">chat_bubble_outline</span>
																					<span
																						v-if="findingCommentsCount[item.id] > 0"
																						class="comment-badge">{{
																						findingCommentsCount[item.id]
																						}}</span>
																				</button>
																			</div>
																		</td>

																		<td>
																			<div class="result-text"
																				v-html="item.text" />
																			<div @click="selectRemark(item)"
																				v-if="item.remark_uid"
																				class="remark-info">
																				{{ item.remark_uid }}
																			</div>

																			<div v-if="item.refResults">
																				<div v-for="itemRef in item.refResults"
																					:key="itemRef.id">
																					{{ itemRef.state }}:
																					<span class="result-text"
																						v-html="itemRef.text" />
																				</div>
																			</div>

																			<div v-if="item.gps && item.gps.lat != ''">
																				<a class="remark-info" :href="'https://www.google.com/maps/place/' +
																					item.gps.lat +
																					'+' +
																					item.gps.lng
																					" target="_blank">Google Maps</a>
																			</div>
																			<div v-if="
																				item.attachments &&
																				item.attachments.length > 0
																			">
																				<div v-for="(itemPic,
																					index) in item.attachments" :key="index" class="prev-img">
																					<a :href="pictureUrlFull(item.id, itemPic)
																						" target="_blank">
																						<img
																							:src="pictureUrl(item.id, itemPic)" />
																					</a>
																				</div>
																			</div>
																			<div class="clearfix"></div>
																			<div v-for="(itemFile,
																				index) in item.attachments_file" :key="index" class="prev-file">
																				<a :href="imgUrl +
																					project_id +
																					'/' +
																					inspectionEntry.uid +
																					'/' +
																					itemFile.file
																					" target="_blank">
																					{{ truncateText(itemFile.file, 30)
																					}}
																				</a>
																			</div>
																		</td>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>
												</div>
												<div class="col-sm-3" v-if="showPreview">
													<div style="text-align: right;">
														<a href="#" @click="showPreview = false">Close</a>
													</div>

													<iframe :src="pdfUrl" width="100%" class="iframe-height"></iframe>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- content @e -->
			</div>
			<!-- wrap @e -->
		</div>
		<!-- main @e -->

		<!-- Keyboard Shortcuts Overlay -->
		<div class="shortcut-overlay" v-if="showShortcutOverlay" @click.self="showShortcutOverlay = false">
			<div class="shortcut-modal">
				<div class="shortcut-header">
					<h5>Keyboard Shortcuts</h5>
					<button class="btn btn-sm btn-icon" @click="showShortcutOverlay = false">
						<span class="material-icons">close</span>
					</button>
				</div>
				<div class="shortcut-body">
					<table class="table table-sm">
						<tbody>
							<tr>
								<td><kbd>[</kbd> / <kbd>]</kbd></td>
								<td>Sidebar ein-/ausblenden</td>
							</tr>
							<tr>
								<td>
									<span v-if="!isMac"><kbd>Alt</kbd> + <kbd>V</kbd></span>
									<span v-else><kbd>Ctrl</kbd> + <kbd>V</kbd></span>
								</td>
								<td>PDF Vorschau</td>
							</tr>
							<tr>
								<td>
									<span v-if="!isMac"><kbd>Alt</kbd> + <kbd>B</kbd></span>
									<span v-else><kbd>Ctrl</kbd> + <kbd>B</kbd></span>
								</td>
								<td>PDF Bericht erstellen</td>
							</tr>
							<tr>
								<td>
									<span v-if="!isMac"><kbd>Alt</kbd> + <kbd>S</kbd></span>
									<span v-else><kbd>Ctrl</kbd> + <kbd>S</kbd></span>
								</td>
								<td>Speichern</td>
							</tr>
							<tr>
								<td><kbd>Esc</kbd></td>
								<td>Overlay/Dialog schließen</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<ChapterImageModal :findingsForChapter="findingsForChapter" :findingsForChapterAll="findingsForChapterAll"
			:projectNumber="project_id" :inspectionEntry="inspectionEntry" :chapterId="selectedChapterId"
			:projectUid="projectUid" @dialogClosed="dialogClosed" v-if="showChapterImage"></ChapterImageModal>
		<ChapterSettingsModal :projectNumber="project_id" :findingsForChapterAll="findingsForChapterAll"
			:inspectionEntry="inspectionEntry" :list="chapterList" :chapterId="selectedChapterId"
			:projectUid="projectUid" :mode="chapterSettingsMode" @dialogClosed="dialogClosed" v-if="showChapterSettings"></ChapterSettingsModal>
		<InspectionSettings :projectNumber="project_id" :findingsForChapterAll="findingsForChapterAll"
			:inspectionEntry="inspectionEntry" :chapterId="selectedChapterId" :projectUid="projectUid"
			@dialogClosed="dialogClosed" v-if="showReportSettings"></InspectionSettings>
		<FindingCommentsModal :finding="selectedCommentFinding" :projectId="project_id" :inspectId="inspect_id"
			@dialogClosed="findingCommentsDialogClosed" v-if="showFindingComments && selectedCommentFinding">
		</FindingCommentsModal>
	</div>
</template>

<script>
import Header from '../../components/Header.vue';
import {
	getInspections,
	getInspection,
	generateReport,
	generateXLSX,
	getFindingCommentsCount,
} from '@/services/reporting-v3.service';
import ChapterSettingsModal from '../../components/modal/ChapterSettings.vue';
import ChapterImageModal from '../../components/modal/ChapterImageModal.vue';
import InspectionSettings from '../../components/modal/InspectionSettings.vue';
import FindingCommentsModal from '../../components/modal/FindingCommentsModal.vue';
import { EventBus } from '@/event-bus.js';
//import { Multipane, MultipaneResizer } from 'vue-multipane';

export default {
	components: {
		Header,
		ChapterSettingsModal,
		ChapterImageModal,
		InspectionSettings,
		FindingCommentsModal,
		//Multipane,
		//MultipaneResizer
	},
	data() {
		return {
			contentCategory: '',
			lang: 'de',
			inspectionContent: {},
			remarkList: [],
			isPVOrBat: false,
			inspectionEntry: null,
			selectedInspections: [],
			all_findings: [],
			lastVersion: null,
			remarkStage: null,
			projectNumber: null,
			findingsChapters: [],
			findingsForChapter: [],
			findingsForChapterAll: [],
			showChapterSettings: false,
			chapterSettingsMode: 'full',
			detailsGeneral: {},
			showChapterImage: false,
			selectedChapterId: null,
			states: {},
			showReportSettings: false,
			projectUid: null,
			pdfLoading: false,
			chapterList: [],
			loading: false,
			reportName: '',
			inspect_chapter_uid: '',
			isProcessingControl: false,
			inspection_loading: false,
			selected_item: null,
			chapters_settings: {},
			versionList: [],
			showPreview: false,
			inspectionVersion: {},
			imgUrl: 'https://inspect-app-v3.8p2.de/api/img-remark?key=',
			pdfUrl: null,
			// UX Verbesserungen
			sidebarCollapsed: false,
			statusFilter: [], // Array für Multi-Select Filter: ['V', 'I', 'E', 'P', 'PP', 'PPP']
			showShortcutOverlay: false,
			availableStates: ['V', 'I', 'E', 'P', 'PP', 'PPP'],
			inspectionSearch: '', // Suchfeld für Inspektionen
			findingsSearch: '', // Suchfeld für Findings
			// Finding Comments
			showFindingComments: false,
			selectedCommentFinding: null,
			findingCommentsCount: {}, // Map: finding_id -> count
		};
	},
	computed: {
		// Gefilterte Inspektionen basierend auf Suche
		filteredInspections() {
			if (!this.inspectionSearch.trim()) {
				return this.inspections;
			}
			const search = this.inspectionSearch.toLowerCase().trim();
			return this.inspections.filter(item => {
				const name = (item.machineName || item.machine?.name || '').toLowerCase();
				const cat = (item.project_cat || '').toLowerCase();
				const siteNumber = (item.machine?.siteNumber || item.siteNumber || '').toString();
				return name.includes(search) || cat.includes(search) || siteNumber.includes(search);
			});
		},
		filteredFindings() {
			let results = this.findingsForChapter.filter((item) => {
				if (item.invisible) return false;
				// Status-Filter anwenden wenn aktiv
				if (this.statusFilter.length > 0) {
					const itemState = item.last_state || item.state;
					if (!this.statusFilter.includes(itemState)) return false;
				}
				return true;
			});
			// Text-Suche in Findings
			if (this.findingsSearch.trim()) {
				const search = this.findingsSearch.toLowerCase().trim();
				results = results.filter(item => {
					const text = (item.text || '').toLowerCase();
					const pos = (item.pos || '').toString();
					return text.includes(search) || pos.includes(search);
				});
			}
			return results;
		},
		// Zähle Findings pro Status für Filter-Badges
		statusCounts() {
			const counts = {};
			this.availableStates.forEach(state => { counts[state] = 0; });
			this.findingsForChapter.forEach(item => {
				if (!item.invisible) {
					const state = item.last_state || item.state;
					if (counts[state] !== undefined) counts[state]++;
				}
			});
			return counts;
		},
		// Breadcrumb-Daten
		breadcrumbs() {
			const crumbs = [];
			if (this.$store.state.rp_project) {
				crumbs.push({
					label: this.$store.state.rp_project.projectname || this.$store.state.rp_project.name || 'Projekt',
					route: '/project-detail/' + this.$store.state.rp_project.uid
				});
			}
			if (this.inspectionEntry) {
				crumbs.push({
					label: this.inspectionEntry.machineName || this.inspectionEntry.machine?.name,
					route: null
				});
			}
			if (this.selected_item && this.contentCategory === 'findings') {
				crumbs.push({
					label: this.selected_item.title.chapter + ' ' + this.selected_item.title.text,
					route: null
				});
			}
			return crumbs;
		},
		// OS-Erkennung für Shortcuts
		isMac() {
			return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
		},
		// Dynamische Spaltenbreiten
		middleColumnClass() {
			if (this.sidebarCollapsed && this.showPreview) return 'col-sm-3';
			if (this.sidebarCollapsed) return 'col-sm-5';
			if (this.showPreview) return 'col-sm-2';
			return 'col-sm-4';
		},
		contentColumnClass() {
			if (this.sidebarCollapsed && this.showPreview) return 'col-sm-6';
			if (this.sidebarCollapsed) return 'col-sm-7';
			if (this.showPreview) return 'col-sm-5';
			return 'col-sm-6';
		},
		inspections() {
			const src = this.$store.state.rp_inspections;
			if (!src) return [];

			const trimmed = (v) => (v == null ? '' : String(v).trim());

			const buildFull = (item) => {
				const full = trimmed(item.machineFullName);
				if (full) return full;

				const fromMachineName = trimmed(item.machineName);
				const name = trimmed(item.machine?.name);
				const site = trimmed(item.machine?.siteNumber || item.siteNumber);

				if (fromMachineName) return fromMachineName;
				if (name && site) return `${name} (${site})`;
				return name; // letzter Fallback
			};

			const compareFull = (aFull, bFull, ai, bi) => {
				// "12345 (2)" → id, site
				const rx = /^(\d+)\s*\(\s*(\d+)\s*\)$/;
				const ma = aFull.match(rx);
				const mb = bFull.match(rx);

				if (ma && mb) {
					const idA = parseInt(ma[1], 10);
					const idB = parseInt(mb[1], 10);
					if (idA !== idB) return idA - idB;

					const siteA = parseInt(ma[2], 10);
					const siteB = parseInt(mb[2], 10);
					if (siteA !== siteB) return siteA - siteB;

					// Stabilität
					return ai - bi;
				}

				const s = aFull.localeCompare(bFull, undefined, { numeric: true });
				return s !== 0 ? s : ai - bi; // Stabilität
			};

			return (
				src
					.map((item, __index) => ({
						item,
						__index,
						__full: buildFull(item),
					}))
					.sort((a, b) => compareFull(a.__full, b.__full, a.__index, b.__index))
					// Kopien zurückgeben, optional mit gefülltem machineFullName
					.map(({ item, __full }) => ({
						...item,
						machineFullName: item.machineFullName ?? __full,
					}))
			);
		},
		report_role_permissions: function () {
			return this.$store.state.account_role.report == 'write';
		},
		inspection_count: function () {
			return this.$store.state.rp_inspections.length;
		},
	},

	mounted() {
		this.project_id = this.$route.params.project_id;
		this.inspect_id = this.$route.params.inspect_id;
		this.lang = this.$route.params.lang;
		this.inspect_chapter_uid = this.$route.params.uid;

		EventBus.$off('refresh:results');
		EventBus.$on('refresh:results', this.refreshResults);

		document.addEventListener('keydown', this.handleKeydown);

		this.loading = true;
		getInspections(this.project_id, this.inspect_id).then((d) => {
			this.$store.state.rp_project = d.data.project;
			this.$store.state.rp_inspections = d.data.list;

			this.inspectionEntry = this.selectEntryById(this.inspect_id);

			this.inspectionVersion[
				this.inspectionEntry.uid
			] = this.inspectionEntry.rvm.list[
				this.inspectionEntry.rvm.list.length - 1
				];

			this.inspectionChanged();
			this.$store.state.rp_state_color = d.data.colors;
			this.loading = false;
		});
	},
	beforeDestroy() {
		document.removeEventListener('keydown', this.handleKeydown);
	},
	methods: {
		switchLanguage() {
			const newLang = this.lang === 'de' ? 'en' : 'de';
			const newPath = this.$route.path.replace(`/${this.lang}/`, `/${newLang}/`);
			window.location.href = newPath;
		},
		truncateText(text, length) {
			return text.length > length ? text.substring(0, length) + '...' : text;
		},
		// Method to check if an item is selected
		isSelected(uid) {
			return this.selectedInspections.includes(uid);
		},

		// Method to toggle selection
		toggleSelection(item) {
			const index = this.selectedInspections.indexOf(item.uid);
			if (index === -1) {
				this.selectedInspections.push(item.uid);
			} else {
				this.selectedInspections.splice(index, 1);
			}
		},

		// Method to select all items
		selectAll() {
			this.selectedInspections = this.inspections.map((item) => item.uid);
		},

		// Method to deselect all items
		deselectAll() {
			this.selectedInspections = [];
		},

		// Method to get all selected inspection items
		getSelectedInspections() {
			return this.inspections.filter((item) =>
				this.selectedInspections.includes(item.uid)
			);
		},

		async exportSelectedReports() {
			// Funktion als async deklarieren
			if (this.selectedInspections.length === 0) {
				alert(
					this.lang === 'en'
						? 'Please select at least one inspection'
						: 'Bitte wählen Sie mindestens eine Inspektion aus'
				);
				return;
			}

			const selectedItems = this.getSelectedInspections();
			this.pdfLoading = true; // Ladeindikator zu Beginn für alle Operationen aktivieren

			let successCount = 0;
			let failureCount = 0;

			for (const item of selectedItems) {
				// Sequenzielle Iteration durch die ausgewählten Items
				const reportFileNameBase = this.reportName;
				+'_' + item.machineName.replace(/\s+/g, '_') + '_' + item.uid;

				try {
					// Warte, bis generateReport abgeschlossen ist, bevor das nächste Item bearbeitet wird
					const response = await generateReport(
						item.project_id,
						item.uid,
						this.lang,
						reportFileNameBase,
						this.inspectionVersion[item.uid] ||
						item.rvm.list[item.rvm.list.length - 1],
						this.projectUid,
						true
					);

					if (response.data && response.data.file) {
						const pdfUrl =
							this.$apiBase +
							'/pdfViewer/' +
							response.data.file +
							'?inspect_id=' +
							item.project_id +
							'&file=' +
							response.data.file;

						const link = document.createElement('a');
						link.href = pdfUrl;

						const downloadFileName = response.data.file.includes('.pdf')
							? response.data.file
							: reportFileNameBase + '.pdf';
						link.setAttribute('download', downloadFileName);

						link.style.display = 'none';
						document.body.appendChild(link);
						link.click(); // Download starten
						document.body.removeChild(link);

						console.log(
							`Successfully downloaded: ${downloadFileName} for item ${item.uid}`
						);
						successCount++;
					} else {
						failureCount++;
						const errorMessage =
							this.lang === 'en'
								? `Failed to generate report for ${item.machineName ||
								item.uid}: No file data in response.`
								: `Fehler beim Generieren des Berichts für ${item.machineName ||
								item.uid}: Keine Dateidaten in der Antwort.`;
						alert(errorMessage);
						console.error(errorMessage + ` (Item UID: ${item.uid})`);
					}
				} catch (error) {
					failureCount++;
					console.error(`Error generating report for item ${item.uid}:`, error);
					const errorMessage =
						this.lang === 'en'
							? `Error generating report for ${item.machineName ||
							item.uid}. See console for details.`
							: `Fehler beim Generieren des Berichts für ${item.machineName ||
							item.uid}. Details in der Konsole.`;
					alert(errorMessage);
				}
			} // Ende der for...of Schleife

			this.pdfLoading = false; // Ladeindikator deaktivieren, nachdem alle Operationen abgeschlossen sind

			// Zusammenfassende Meldung
			if (selectedItems.length > 1) {
				// Nur bei mehr als einem Item eine Zusammenfassung anzeigen
				if (failureCount > 0 && successCount > 0) {
					alert(
						this.lang === 'en'
							? `${successCount} reports downloaded, ${failureCount} failed.`
							: `${successCount} Berichte heruntergeladen, ${failureCount} fehlgeschlagen.`
					);
				} else if (failureCount > 0 && successCount === 0) {
					alert(
						this.lang === 'en'
							? `All ${failureCount} report generation attempts failed.`
							: `Alle ${failureCount} Versuche zur Berichterstellung sind fehlgeschlagen.`
					);
				} else if (successCount > 0 && failureCount === 0) {
					//alert(this.lang === 'en' ? `All ${successCount} reports downloaded successfully.` : `Alle ${successCount} Berichte erfolgreich heruntergeladen.`);
				}
			} else if (selectedItems.length === 1 && failureCount > 0) {
				// Der individuelle Alert hat bereits informiert, hier ist keine weitere Zusammenfassung nötig, wenn nur ein Item fehlschlug.
			} else if (selectedItems.length === 1 && successCount > 0) {
				// Optional: Zusätzliche Erfolgsmeldung, wenn nur ein Bericht erfolgreich war
				// alert(this.lang === 'en' ? 'Report downloaded successfully.' : 'Bericht erfolgreich heruntergeladen.');
			}
		},

		handleKeydown(event) {
			// Overlay schließen mit Escape
			if (event.key === 'Escape' && this.showShortcutOverlay) {
				this.showShortcutOverlay = false;
				event.preventDefault();
				return;
			}

			// Sidebar toggle mit [ oder ]
			if (event.key === '[' || event.key === ']') {
				this.sidebarCollapsed = !this.sidebarCollapsed;
				event.preventDefault();
				return;
			}

			// Alt+V (Windows) oder Ctrl+V (Mac) = PDF Vorschau
			const isVKey = event.key === 'V' || event.key === 'v';
			const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
			if (isVKey && (event.altKey || (isMac && event.ctrlKey && !event.metaKey))) {
				this.generatePdfReport(false);
				event.stopPropagation();
				event.preventDefault();
				return;
			}

			// Alt+B (Windows) oder Ctrl+B (Mac) = PDF Bericht erstellen
			const isBKey = event.key === 'B' || event.key === 'b';
			if (isBKey && (event.altKey || (isMac && event.ctrlKey && !event.metaKey))) {
				this.generatePdfReport(true);
				event.stopPropagation();
				event.preventDefault();
				return;
			}

			// Alt+S (Windows) oder Ctrl+S (Mac) = Speichern
			const isSKey = event.key === 'S' || event.key === 's';
			if (isSKey && (event.altKey || (isMac && event.ctrlKey && !event.metaKey))) {
				EventBus.$emit('keydown', 'save');
				event.preventDefault();
				return;
			}
		},

		// Status-Filter toggle
		toggleStatusFilter(state) {
			const idx = this.statusFilter.indexOf(state);
			if (idx === -1) {
				this.statusFilter.push(state);
			} else {
				this.statusFilter.splice(idx, 1);
			}
		},

		refreshResults(d) {
			if (this.project_id == d.project_id && this.inspect_id == d.inspect_id) {
				console.log('neu laen');
				this.loadInspection();
			}
		},
		selectEntryById(inspect_id) {
			for (let i = 0; i < this.inspections.length; i++) {
				if (this.inspections[i].uid == inspect_id) {
					return this.inspections[i];
				}
			}
			return this.inspections[0];
		},
		changeVersion() {
			this.inspectionVersion[this.inspectionEntry.uid] = this.lastVersion;
			this.inspectionChanged();
		},
		selectRemark(item) {
			this.$store.socket.sendRSelectRemark(
				item.remark_uid,
				this.project_id,
				this.inspect_id
			);
		},
		stateColorStyle: function (state) {
			return {
				background: this.$store.state.rp_state_color[state],
				'border-color': this.$store.state.rp_state_color[state],
			};
		},
		renameState: function (state) {
			if (this.states[state]) {
				return this.states[state];
			}
			return state;
		},
		dialogClosed: function (data) {
			if (data && data.cat == 'inspection' && data.saved) {
				// Refresh Inspections
				this.loadInspection();
			}
			this.showChapterSettings = false;
			this.chapterSettingsMode = 'full';
			this.showChapterImage = false;
			this.showReportSettings = false;
			this._updateChapterSettings();
		},
		// Finding Number with Chapter Prefix (only for processing_control_expanded)
		getFullFindingNumber(pos) {
			if (this.isProcessingControl && this.selected_item && this.selected_item.title && this.selected_item.title.chapter) {
				return this.selected_item.title.chapter + '.' + pos;
			}
			return pos;
		},
		// Finding Comments Methods
		openFindingComments(item) {
			this.selectedCommentFinding = item;
			this.showFindingComments = true;
		},
		findingCommentsDialogClosed(data) {
			if (data && data.commentsCount !== undefined && this.selectedCommentFinding) {
				this.$set(this.findingCommentsCount, this.selectedCommentFinding.id, data.commentsCount);
			}
			this.showFindingComments = false;
			this.selectedCommentFinding = null;
		},
		getCommentButtonTitle(item) {
			const count = this.findingCommentsCount[item.id] || 0;
			if (count === 0) return 'Kommentar hinzufügen';
			return count === 1 ? '1 Kommentar' : count + ' Kommentare';
		},
		async loadFindingCommentsCount() {
			if (!this.project_id || !this.inspect_id) return;
			try {
				const response = await getFindingCommentsCount(this.project_id, this.inspect_id);
				if (response && response.data && response.data.counts) {
					this.findingCommentsCount = response.data.counts;
				}
			} catch (error) {
				console.error('Error loading comments count:', error);
			}
		},
		pictureUrlFull: function (id, attachment) {
			let key = '';

			if (attachment.project_id) {
				key += attachment.project_id + '/';
			} else {
				key += this.project_id + '/';
			}

			if (attachment.inspect_id) {
				key += attachment.inspect_id + '/';
			} else {
				key += this.inspect_id + '/';
			}

			key += attachment.file;
			//console.log(attachment, this.$apiBase)
			return this.$apiBase + '/img-remark/' + '?key=' + key;
		},

		pictureUrl: function (id, attachment) {
			let key = '';

			if (attachment.project_id) {
				key += attachment.project_id + '/';
			} else {
				key += this.project_id + '/';
			}

			if (attachment.inspect_id) {
				key += attachment.inspect_id + '/';
			} else {
				key += this.inspect_id + '/';
			}

			key += attachment.file;
			//console.log(attachment, this.$apiBase)
			return this.$apiBase + '/img-url?key=' + key;
		},
		reportSettings: function (inspection_entry) {
			this.showReportSettings = true;
			console.log('inspection', inspection_entry.inspection);
		},
		chapterImage: function (id) {
			this.selectFindingsChapter(id);
			this.selectedChapterId = id;
			this.showChapterImage = true;
		},
		chapterSettings: function (item) {
			console.log(item);
			// this.selectFindingsChapter(id);
			this.selectedChapterId = item;
			this.chapterList = item.list;
			this.showChapterSettings = true;
		},
		componentSettings: function () {
			this.selectedChapterId = {
				uid: 'components',
				id: 'components',
				chapter: '',
				level: 0,
				title: { chapter: '', text: 'components' },
			};
			this.chapterSettingsMode = 'imageOnly';
			this.showChapterSettings = true;
		},
		generateXLSX: function () {
			//const ref = this;

			generateXLSX(
				this.inspectionEntry.project_id,
				this.inspectionEntry.inspect_id,
				this.lang,
				this.reportName,
				this.lastVersion,
				this.projectUid
			).then((d) => {
				if (d.data) {
					console.log(d.data);
				}
			});
		},
		generatePdfReport: function (download) {
			const ref = this;

			this.pdfLoading = true;
			generateReport(
				this.inspectionEntry.project_id,
				this.inspectionEntry.inspect_id,
				this.lang,
				this.reportName,
				this.lastVersion,
				this.projectUid
			)
				.then((d) => {
					setTimeout(function () {
						ref.pdfLoading = false;

						if (d.data && d.data.file) {
							// Stellen Sie sicher, dass d.data und d.data.file existieren

							if (download) {
								// URL zum PDF erstellen
								const pdfUrl =
									ref.$apiBase +
									'/pdfViewer/' +
									d.data.file +
									'?inspect_id=' +
									ref.inspectionEntry.project_id +
									'&file=' +
									d.data.file;

								// Einen temporären Link erstellen
								const link = document.createElement('a');
								link.href = pdfUrl;

								// Das 'download'-Attribut mit dem gewünschten Dateinamen setzen
								// d.data.file scheint der Dateiname zu sein, verwenden Sie ihn oder einen anderen gewünschten Namen
								link.setAttribute('download', d.data.file);

								// Den Link unsichtbar machen und zum Body hinzufügen
								link.style.display = 'none';
								document.body.appendChild(link);

								// Den Klick auf den Link simulieren, um den Download zu starten
								link.click();

								// Den Link aus dem DOM entfernen
								document.body.removeChild(link);
							} else {
								ref.showPreview = true;
								ref.pdfUrl =
									ref.$pdfBase +
									'/pdfViewerInline/' +
									d.data.file +
									'?inspect_id=' +
									ref.inspectionEntry.project_id +
									'&file=' +
									d.data.file +
									'&t=' +
									new Date().getTime();
							}
						} else {
							// Fehlerbehandlung, falls d.data oder d.data.file nicht vorhanden sind
							console.error('PDF-Daten nicht empfangen oder Dateiname fehlt.');
							// Hier könnten Sie eine Benachrichtigung für den Benutzer hinzufügen
						}
					}, 500);
				})
				.catch((error) => {
					// Fehlerbehandlung für den generateReport Promise
					console.error('Fehler beim Generieren des Reports:', error);
					ref.pdfLoading = false;
					// Hier könnten Sie eine Benachrichtigung für den Benutzer hinzufügen
				});
		},

		selectChapter: function (item) {
			this.contentCategory = item;
			console.log(item);
		},

		selectFindingsChapter: function (item) {
			console.log('__selectFindingsChapter__', item);

			this.contentCategory = 'findings';
			this.findingsSearch = ''; // Suche zurücksetzen bei Kapitelwechsel

			this.findingsForChapterAll = this.findAllFindingsInAllLevel(
				item.uid,
				item.level
			);

			this.selected_item = item;

			this.inspect_chapter_uid = item.uid;
			history.pushState(
				{},
				null,
				'/report-v3/' +
				this.lang +
				'/' +
				this.inspectionEntry.project_id +
				'/' +
				this.inspectionEntry.uid +
				'/' +
				item.uid
			);

			// console.log("____",   this.inspectionContent.processingState.map[item.uid])

			this.findingsForChapter = this.findingsForChapterAll; // item.list;

			for (let i = 0; i < this.findingsForChapter.length; i++) {
				if (
					this.findingsForChapter[i].refResults &&
					this.findingsForChapter[i].refResults.length > 0
				) {
					this.findingsForChapter[i].attachments = this.findingsForChapter[
						i
					].refResults[
						this.findingsForChapter[i].refResults.length - 1
					].attachments;
					this.findingsForChapter[i].attachments_file = this.findingsForChapter[
						i
					].refResults[
						this.findingsForChapter[i].refResults.length - 1
					].attachments_file;
					this.findingsForChapter[i].pictures = this.findingsForChapter[
						i
					].refResults[
						this.findingsForChapter[i].refResults.length - 1
					].pictures;
				}
			}

			console.log(
				'==this.findingsForChapterAll',
				this.findingsForChapterAll,
				'___',
				this.findingsForChapter
			);
			//this.allFindings(id, true);
		},
		selectInspectionRow(val) {
			this.showPreview = false;
			this.inspectionEntry = val;
			this.inspectionChanged();
		},

		loadInspection: function () {
			this.inspection_loading = true;

			getInspection(
				this.inspectionEntry.project_id,
				this.inspectionEntry.uid,
				this.lang,
				this.inspectionVersion[this.inspectionEntry.uid],
				this.$store.state.rp_project ? this.$store.state.rp_project.uid : null
			).then((d) => {
				this.findingsChapters = [];

				console.log('INSPECTION', d.data);

				//this.chapters_settings = d.data.chapters_settings

				this.$store.state.chapters_settings = d.data.chapters_settings;

				this.all_findings = d.data.content.v.findings.list;

				this.setFindingsChapters(
					this.all_findings,
					this.$store.state.chapters_settings
				);

				this.inspectionContent = d.data.content.v;
				this.inspection_base = d.data.inspection;

				this.detailsGeneral = d.data.detailsGeneral;

				this.$store.state.inspectionContent = this.inspectionContent;

				//this.lastVersion = d.data.lastVersion;

				this.setMainChapters(d.data.content.v);

				this.reportName = d.data.reportName;
				this.projectUid = d.data.project_uid;

				this.inspection_loading = false;

				this.states = d.data.states;

				if (
					d.data.inspection &&
					d.data.inspection.rvm &&
					d.data.inspection.rvm.list
				) {
					this.versionList = d.data.inspection.rvm.list;
				}

				this.isPVOrBat = d.data.isBAT || d.data.isPV;
				//  this.inspection_base.project_cat == "PV" ||
				//  this.inspection_base.project_cat == "BAT";

				console.log(
					'isPVOrBat',
					this.isPVOrBat,
					d.data.isBAT,
					d.data.isPV,
					this.inspection_base.project_cat
				);

				this.isProcessingControl =
					this.inspection_base.processingControl &&
					this.inspection_base.processingControlExpanded;

				// Load comment counts for this inspection
				this.loadFindingCommentsCount();

				if (this.inspect_chapter_uid) {
					for (let k = 0; k < this.findingsChapters.length; k++) {
						if (this.findingsChapters[k].uid == this.inspect_chapter_uid) {
							console.log('ja ich bin', this.findingsChapters[k]);
							this.selectFindingsChapter(this.findingsChapters[k]);
							break;
						}
					}
					console.log(this.findingsChapters, '----', this.inspect_chapter_uid);
				} else {
					this.selectChapter('general');
				}
			});
		},
		inspectionChanged: function () {
			this.findingsForChapter = [];
			if (this.inspectionEntry) {
				if (!this.inspectionVersion[this.inspectionEntry.uid]) {
					this.inspectionVersion[
						this.inspectionEntry.uid
					] = this.inspectionEntry.rvm.list[
						this.inspectionEntry.rvm.list.length - 1
						];
				}
				this.lastVersion = this.inspectionVersion[this.inspectionEntry.uid];

				this.inspect_id = this.inspectionEntry.uid;

				history.pushState(
					{},
					null,
					'/report-v3/' +
					this.lang +
					'/' +
					this.inspectionEntry.project_id +
					'/' +
					this.inspectionEntry.uid
				);

				this.loadInspection();
			}
		},

		findAllFindingsInAllLevel(uid, level) {
			let start = false;

			let int_list = [];

			console.log('findAllFindingsInAllLevel', uid, level, this.all_findings);

			for (let i = 0; i < this.all_findings.length; i++) {
				if (this.all_findings[i].id == uid) {
					start = true;
					for (let m = 0; m < this.all_findings[i].list.length; m++) {
						int_list.push(this.all_findings[i].list[m]);
					}
				} else if (start && this.all_findings[i].level > level) {
					for (let m = 0; m < this.all_findings[i].list.length; m++) {
						int_list.push(this.all_findings[i].list[m]);
					}
				} else {
					if (start) {
						break;
					}
				}
			}

			return int_list;
		},

		setFindingsChapters(list, chapter_settings) {
			for (let i = 0; i < list.length; i++) {
				let chapter_entry = {};

				for (let k = 0; k < chapter_settings.length; k++) {
					let chapterIdPrx =
						list[i].title.chapter && list[i].title.chapter.length > 0
							? list[i].title.chapter + '-'
							: '';

					if (
						chapter_settings[k].chapterId ==
						chapterIdPrx + '' + list[i].level + '-' + list[i].title.text
					) {
						chapter_entry = chapter_settings[k];
						break;
					}
				}

				//console.log(list[i]);
				this.findingsChapters.push({
					level: list[i].level,
					uid: list[i].id,
					title: list[i].title,
					chapter: list[i].title.chapter,
					list: list[i].list,
					id: list[i].level + '-' + list[i].title.text,
					count: list[i].list ? list[i].list.length : 0,
					//chapter_entry: chapter_entry,
					chapterimage: chapter_entry.chapterimage,
					chapterfile: chapter_entry.chapterfile,
					chapterincludes: chapter_entry.chapterincludes,
					chapterV: chapter_entry.chapterV,
					newpagepictures: chapter_entry.newpagepictures,
					newpage: chapter_entry.newpage,
				});
			}
		},

		setMainChapters(obj) {
			console.log('setMainChapters', obj);

			this.$store.state.main_chapters = [];

			this.$store.state.main_chapters.push({
				id: 'inspectionDetails',
				chapter: obj.inspectionDetails.title.chapter,
				title: obj.inspectionDetails.title.text,
			});

			this.$store.state.main_chapters.push({
				id: 'general',
				chapter: obj.general.title.chapter,
				title: obj.general.title.text,
			});

			if (obj.general.list) {
				for (let m = 0; m < obj.general.list.length; m++) {
					// Use consistent ID format: remove dots from chapter numbers
					const chapterNum = obj.general.list[m].title.chapter;
					const chapterId = 'general' + chapterNum.replace(/\./g, '');

					this.$store.state.main_chapters.push({
						id: chapterId,
						chapter: chapterNum,
						title: obj.general.list[m].title.text,
					});
				}
			}

			// Ensure B.1 to B.5 exist (add if not already present from obj.general.list)
			const existingGeneralChapters = this.$store.state.main_chapters.map(
				(ch) => ch.chapter
			);

			const predefinedSubChapters = [
				{ id: 'generalB1', chapter: 'B.1', title: 'General B.1' },
				{ id: 'generalB2', chapter: 'B.2', title: 'General B.2' },
				{ id: 'generalB3', chapter: 'B.3', title: 'General B.3' },
				{ id: 'generalB4', chapter: 'B.4', title: 'General B.4' },
				{ id: 'generalB5', chapter: 'B.5', title: 'General B.5' },
			];

			for (const subChapter of predefinedSubChapters) {
				if (!existingGeneralChapters.includes(subChapter.chapter)) {
					this.$store.state.main_chapters.push(subChapter);
				}
			}

			this.$store.state.main_chapters.push({
				id: 'machinedata',
				chapter: obj.machinedata.title.chapter,
				title: obj.machinedata.title.text,
			});

			if (
				this.detailsGeneral &&
				this.detailsGeneral.general &&
				!this.detailsGeneral.general.processing_control_expanded
			) {
				this.$store.state.main_chapters.push({
					id: 'components',
					chapter: obj.components.title ? obj.components.title.chapter : '',
					title: obj.components.title ? obj.components.title.text : '',
				});
			}

			this.$store.state.main_chapters.push({
				id: 'findings',
				chapter: obj.findings.title.chapter,
				title: obj.findings.title.text,
			});

			for (let i = 0; i < this.findingsChapters.length; i++) {
				if (this.findingsChapters[i].level < 3) {
					this.$store.state.main_chapters.push({
						id: 'findings' + i,
						chapter: this.findingsChapters[i].title.chapter,
						title: this.findingsChapters[i].title.text,
					});
				}
			}

			this.$store.state.main_chapters.push({
				id: 'conclusion',
				chapter: obj.conclusion.title.chapter,
				title: obj.conclusion.title.text,
			});

			if (obj.conclusion.chapters) {
				for (let m = 0; m < obj.conclusion.chapters.length; m++) {
					this.$store.state.main_chapters.push({
						id: 'conclusion' + obj.conclusion.chapters[m].title.chapter,
						chapter: obj.conclusion.chapters[m].title.chapter,
						title: obj.conclusion.chapters[m].title.text,
					});
				}
			}

			this.$store.state.main_chapters.push({
				id: 'disclaimer',
				chapter: obj.disclaimer.title.chapter,
				title: obj.disclaimer.title.text,
			});

			this.$store.state.main_chapter = this.shiftChapters(
				this.$store.state.main_chapters
			);

			console.log('main_chapter', this.$store.state.main_chapter);
		},
		shiftChapters: function (chapters) {
			const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
			let currentCharIndex = 0;
			let lastMainChapter = '';

			for (let k = 0; k < chapters.length; k++) {
				let item = chapters[k];
				const parts = item.chapter.split('.');

				if (parts.length == 1) {
					lastMainChapter = alphabet[currentCharIndex++];
					parts[0] = lastMainChapter;
				} else {
					parts[0] = lastMainChapter;
				}

				if (currentCharIndex >= alphabet.length) {
					currentCharIndex = 0;
				}
				// Baut das neue Kapitel zusammen
				const newChapter = parts.join('.');

				item.chapter = newChapter;
			}

			return chapters;
		},

		allFindings: function (id, allLevel) {
			let found = false;
			let level = 0;
			this.findingsForChapter = [];

			for (let k = 0; k < this.inspectionEntry.findings.list.length; k++) {
				if (found) {
					if (this.inspectionEntry.findings.list[k].level > level) {
						for (
							let m = 0;
							m < this.inspectionEntry.findings.list[k].list.length;
							m++
						) {
							this.findingsForChapter.push(
								this.inspectionEntry.findings.list[k].list[m]
							);
						}
					} else {
						break;
					}
				}

				if (this.inspectionEntry.findings.list[k].id == id) {
					console.log(this.inspectionEntry.findings.list[k]);
					level = this.inspectionEntry.findings.list[k].level;
					found = true;

					for (
						let m = 0;
						m < this.inspectionEntry.findings.list[k].list.length;
						m++
					) {
						this.findingsForChapter.push(
							this.inspectionEntry.findings.list[k].list[m]
						);
					}
				}

				if (!allLevel) {
					break;
				}
			}
		},

		_findings: function (list) {
			if (list && list.length > 0) {
				for (let k = 0; k < list.length; k++) {
					if (list[k].level) {
						//console.log(list[k].level, list[k], list[k].title.text, list[k].id);
						list[k].uid = list[k].id + '-' + Math.random();
						this.findingsChapters.push(list[k]);
					}
				}
			}
			this._updateChapterSettings();
		},
		_updateChapterSettings: function () {
			for (let n = 0; n < this.findingsChapters.length; n++) {
				this.findingsChapters[n].chapterimage = false;
				for (
					let m = 0;
					m < this.$store.state.rp_chapters_settings.length;
					m++
				) {
					if (
						this.$store.state.rp_chapters_settings[m].chapterId ==
						this.findingsChapters[n].id
					) {
						this.findingsChapters[n].chapterimage = this.$store.state
							.rp_chapters_settings[m].chapterimage
							? this.$store.state.rp_chapters_settings[m].chapterimage
							: false;
						break;
					}
				}
			}

			//let cache_findings = JSON.parse(JSON.stringify(this.findingsChapters));
			this.findingsChapters = [];

			this.setFindingsChapters(
				this.all_findings,
				this.$store.state.chapters_settings
			);
		},
		selectInspection: function () {
			this.findingsChapters = [];
			this._findings(this.inspectionEntry.findings.list);
		},
		downloadURI: function (uri, name) {
			var link = document.createElement('a');
			link.download = name;
			link.href = uri;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		saveCanvas: function () {
			var dataURL = this.remarkStage.toDataURL({
				pixelRatio: 1,
			});

			this.downloadURI(dataURL, 'stage.png');
		},
		generateMarker: function (id, nr, posX, posY, textPosX, textPosY, color) {
			const ref = this;

			var group = new this.$konva.Group({
				draggable: true,
				x: posX,
				y: posY,
				id: id,
			});
			var node = new this.$konva.Circle({
				stroke: color,
				strokeWidth: 2,
				radius: 10,
				x: 10,
				y: 10,
			});
			group.on('dragend', function () {
				ref.updateRemarkPos(
					group.id(),
					group.x(),
					group.y(),
					simpleText.x(),
					simpleText.y()
				);

				//var dataURL = stage.toDataURL({ pixelRatio: 1 });
				//console.log(dataURL)
			});
			group.add(node);
			var simpleText = new this.$konva.Text({
				text: nr,
				//align: 'center',
				x: textPosX,
				y: textPosY,
				width: 40,
				fontSize: 18,
				fontFamily: 'Arial',
				fill: color,
			});
			group.add(simpleText);

			group.on('mouseenter', function () {
				ref.remarkStage.container().style.cursor = 'pointer';
			});
			group.on('mouseleave', function () {
				ref.remarkStage.container().style.cursor = 'default';
			});
			simpleText.on('pointerdblclick', function () {
				//group.draggable = false
				simpleText.startDrag();
				//simpleText.draggable = true
			});
			return group;
		},
		updateRemarkPos: function (id, x, y, tX, tY) {
			for (let k = 0; k < this.remarkList.length; k++) {
				if (this.remarkList[k].id == id) {
					this.remarkList[k].x = x;
					this.remarkList[k].y = y;
					this.remarkList[k].tX = tX;
					this.remarkList[k].tY = tY;
					return;
				}
			}
		},
	},
};
</script>

<style scoped>
.chapterTable {
	margin-top: 10px;
	padding-top: 10px;
	border-top: 1px solid #cccccc;
	border-bottom: 1px solid #cccccc;
	margin-bottom: 20px;
}

.chapterRow {
	cursor: pointer;
	padding: 4px 10px 4px 0;
	position: relative;
	display: table;
	width: 100%;
}

.chapterRow>.chapterRow-col1 {
	display: table-cell;
	vertical-align: top;
	width: 20px;
}

.chapterRow>.chapterRow-col2 {
	display: table-cell;
	vertical-align: top;
	font-size: 15px;
}

.chapterRow>.chapterRow-col3 {
	display: table-cell;
	vertical-align: top;
	width: 20px;
}

.chapterRow>.chapterRow-col2:hover {
	color: #798bff;
}

.chaper-icon>.material-icons {
	font-size: 18px;
	color: #8094ae;
}

.statev {
	border-color: #3bc600;
	background-color: #3bc600;
}

.wide-large {
	max-width: 100% !important;
}

.prev-file {
	display: block;
	padding-top: 5px;
}

.prev-img {
	float: left;
	padding-right: 10px;
	padding-top: 10px;
}

.prev-img img {
	width: 110px;
	padding-bottom: 5px;
}

.result-text {
	font-size: 16px;
}

.inspection-row {
	cursor: pointer;
}

.container-col1 {
	height: calc(100vh - 150px);
	/* Maximale Höhe des Browserfensters */
	overflow-y: auto;
	/* Scrollbalken anzeigen, wenn der Inhalt zu lang ist */
}

.remark-info {
	font-size: 12px;
	color: #999999;
	cursor: pointer;
}

.chapter-headline {
	padding-bottom: 5px;
	padding-top: 5px;
	cursor: pointer;
}

h6:hover {
	color: #798bff;
}

.insection_selected {
	background-color: #8094ae;
	color: #ffffff;
}

h4,
.h4 {
	font-size: 1.3rem;
}

.iframe-height {
	min-height: 700px;
	height: 80vh;
}

.multipane.foo.layout-v .multipane-resizer {
	margin: 0;
	left: 0;
	/* reset default styling */
	width: 15px;
	background: blue;
}

.multipane.foo.layout-h .multipane-resizer {
	margin: 0;
	top: 0;
	/* reset default styling */
	height: 15px;
	background: blue;
}

.btn-list {
	width: 100%;
	text-align: right;
	margin-bottom: 20px;
}

.dropdown-menu {
	width: 250px;
}

/* === UX Verbesserungen === */

/* Breadcrumb Container */
.breadcrumb-container {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 8px 15px;
	background-color: #f8f9fa;
	border-bottom: 1px solid #e5e9f2;
}

.breadcrumb-left {
	display: flex;
	align-items: center;
	gap: 10px;
}

.breadcrumb-container .breadcrumb {
	background: transparent;
	padding: 0;
	margin: 0;
	font-size: 14px;
}

.breadcrumb-container .breadcrumb-item a {
	color: #6576ff;
}

.breadcrumb-container .breadcrumb-item.active {
	color: #364a63;
	font-weight: 500;
}

.breadcrumb-right-actions {
	display: flex;
	align-items: center;
	gap: 8px;
}

.lang-toggle {
	font-weight: 600;
	font-size: 12px;
	padding: 4px 10px;
	border: 1px solid #dbdfea;
	background: #fff;
	color: #526484;
	border-radius: 4px;
	transition: all 0.2s;
}

.lang-toggle:hover {
	background: #6576ff;
	color: #fff;
	border-color: #6576ff;
}

.shortcut-hint {
	color: #8094ae;
	opacity: 0.7;
	transition: opacity 0.2s;
}

.shortcut-hint:hover {
	opacity: 1;
}

/* Sidebar Toggle Button */
.sidebar-toggle-btn {
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 6px 10px;
	background: #fff;
	border: 1px solid #e5e9f2;
	border-radius: 4px;
	color: #526484;
	transition: all 0.2s;
}

.sidebar-toggle-btn:hover {
	background: #e5e9f2;
	color: #364a63;
}

.sidebar-toggle-btn .material-icons {
	font-size: 20px;
}

.sidebar-toggle-btn .sidebar-count {
	font-size: 11px;
	font-weight: 600;
	background: #6576ff;
	color: #fff;
	padding: 2px 6px;
	border-radius: 10px;
	min-width: 20px;
	text-align: center;
}

.sidebar-hidden {
	display: none !important;
}

/* Chapter Column */
.chapter-column {
	background-color: #f5f6fa;
	padding-top: 20px;
	padding-bottom: 20px;
	transition: all 0.3s ease;
}

/* Content Column */
.content-column {
	padding: 20px;
	transition: all 0.3s ease;
}

/* Status Filter Bar */
.status-filter-bar {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 8px;
	padding: 12px 0;
	margin-bottom: 15px;
	border-bottom: 1px solid #e5e9f2;
}

.status-filter-bar .filter-label {
	font-size: 13px;
	color: #8094ae;
	font-weight: 500;
}

.status-filter-bar .status-filter-btn {
	border-radius: 20px;
	padding: 4px 12px;
	font-size: 12px;
	transition: all 0.2s;
}

.status-filter-bar .status-filter-btn.active {
	color: #fff;
	border-color: transparent;
}

.status-filter-bar .status-filter-btn:disabled {
	opacity: 0.4;
	cursor: not-allowed;
}

.status-filter-bar .filter-result-count {
	margin-left: auto;
	font-size: 12px;
	color: #8094ae;
}

/* Keyboard Shortcuts Overlay */
.shortcut-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	z-index: 9999;
	display: flex;
	align-items: center;
	justify-content: center;
}

.shortcut-modal {
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
	min-width: 400px;
	max-width: 500px;
}

.shortcut-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px 20px;
	border-bottom: 1px solid #e5e9f2;
}

.shortcut-header h5 {
	margin: 0;
	font-size: 16px;
	font-weight: 600;
}

.shortcut-body {
	padding: 15px 20px;
}

.shortcut-body table {
	margin: 0;
}

.shortcut-body td {
	padding: 8px 0;
	vertical-align: middle;
}

.shortcut-body td:first-child {
	width: 180px;
	text-align: left;
}

kbd {
	background: #e8e9ed;
	border: 1px solid #d0d4db;
	border-radius: 4px;
	padding: 3px 8px;
	font-size: 12px;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
	font-weight: 600;
	color: #364a63;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* Findings Search */
.findings-search {
	position: relative;
	flex: 0 0 150px;
	margin-left: auto;
}

.findings-search input {
	padding-right: 25px;
	font-size: 12px;
}

.findings-search .search-clear {
	position: absolute;
	right: 8px;
	top: 50%;
	transform: translateY(-50%);
	cursor: pointer;
	color: #8094ae;
	font-size: 16px;
	line-height: 1;
}

.findings-search .search-clear:hover {
	color: #364a63;
}

/* Findings Table Container mit Sticky Header */
.findings-table-container {
	max-height: calc(100vh - 350px);
	overflow-y: auto;
	border: 1px solid #e5e9f2;
	border-radius: 4px;
}

.findings-table {
	margin-bottom: 0;
}

.findings-table .sticky-header {
	position: sticky;
	top: 0;
	background: #f8f9fa;
	z-index: 10;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.findings-table .sticky-header th {
	border-top: none;
	padding: 10px 8px;
	font-weight: 600;
	color: #526484;
}

/* Finding Comments Button */
.status-cell {
	display: flex;
	align-items: center;
	gap: 6px;
}

.comment-btn {
	position: relative;
	padding: 2px 4px;
	color: #8094ae;
	background: transparent;
	border: none;
	opacity: 0.6;
	transition: all 0.2s;
}

.comment-btn:hover {
	opacity: 1;
	color: #6576ff;
	background: rgba(101, 118, 255, 0.1);
}

.comment-btn .material-icons {
	font-size: 18px;
}

.comment-btn .comment-badge {
	position: absolute;
	top: -4px;
	right: -4px;
	background: #6576ff;
	color: #fff;
	font-size: 10px;
	font-weight: 600;
	min-width: 16px;
	height: 16px;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 4px;
}

/* Highlight rows with comments */
.findings-table tr:has(.comment-badge) {
	background-color: rgba(101, 118, 255, 0.03);
}
</style>
